const formatNumber = number => {
    return (number==null || number==undefined) ? '' : Math.round(parseFloat(number)).toLocaleString();
};

export { formatNumber };